










import { Vue, Component, Watch, Prop } from 'vue-property-decorator'

@Component
export default class Form extends Vue {
  /** 接口字段说明
     * inpVal 文本域内容
     * type 输入框类型 text textarea number password 常用类型， text   select
     * disabled 禁用状态
     * label  标签内容
     */
  inpVal:(string | number) = ''
  type:string = ''
  disabled: boolean = false
  label: (string | number) = ''
  labelWidth: (number | string) = 80
  inputWidth: (number | string) = 80
  // this.type = type
  @Watch('inpVal')
  handle(val:any) {
    this.$nextTick(() => {
      this.$attrs.value = val
      this.$emit('input', val)
    })
  }

  created() {
    const {
      value,
      type,
      disabled,
      label } = this.$attrs

    this.inpVal = value
    this.type = value
    this.disabled = Boolean(disabled)
    this.label = label
    console.log(this)
  }
  handlexxx() {
    console.log('zixx')
  }
}
